(function () {
  // Section Rendering API / theme editor re-renders can re-run this script.
  if (window.upsellAddToCartAnalyticsBound) return;
  window.upsellAddToCartAnalyticsBound = true;

  window.trackUpsellAdd = function (el) {
    if (!window.Shopify?.analytics?.publish || !el) return;

    const payload = {
      upsell_location: 'cart_drawer',
      item_id: el.dataset.itemId || '',
      item_name: el.dataset.itemName || '',
      item_variant: el.dataset.itemVariant || '',
      item_category: el.dataset.itemCategory || '',
      price: parseFloat(el.dataset.price) || 0,
      quantity: 1
    };

    Shopify.analytics.publish('upsell_add_to_cart', payload);
    
  };
})();
